import { Component, inject } from '@angular/core';
import {
  CloudUploadService,
} from '../../core/services/cloud-upload.service';
import { Observable } from 'rxjs';
import { UploadSession } from '../../core/models/upload-session.model';

@Component({
  selector: 'black-file-upload-tracker',
  standalone: false,
  templateUrl: './file-upload-tracker.component.html',
  styleUrl: './file-upload-tracker.component.css',
})
export class FileUploadTrackerComponent {
  private uploadService = inject(CloudUploadService);

  uploads$: Observable<UploadSession[]>;
  isOpen = false;

  constructor() {
    this.uploads$ = this.uploadService.uploads$;
  }

  togglePanel() {
    this.isOpen = !this.isOpen;
  }

  clearCompleted() {
    this.uploadService.uploads$.subscribe((uploads) => {
      uploads
        .filter((upload) => upload.uploadStatus === 'completed')
        .forEach((upload) => this.uploadService.removeUpload(upload.id));
    });
  }
}
